import React, { memo } from 'react'

import { List } from '@fourthwall/components'

import type { Item, Mode, SelectMode } from '../../SelectProductsModal.types'
import { ProductsListItem } from '../ProductsListItem/ProductsListItem'

type ProductsListProps = {
  items: Item[]
  hasNextPage: boolean
  multiple: boolean
  selectMode: SelectMode
  innerIds: string[]
  mode: Mode
  productsStates: Record<string, any>
  onSelect: (id: string) => (value: boolean) => void
  onBulkSelect: (ids: string[]) => (value: boolean) => void
}

const MemoizedProductsListItem = memo(ProductsListItem)

export const ProductsList = memo(
  ({
    items,
    hasNextPage,
    multiple,
    selectMode,
    innerIds,
    mode,
    productsStates,
    onSelect,
    onBulkSelect,
  }: ProductsListProps) => {
    const getValue = (item: Item) => {
      if (multiple) {
        if (selectMode === 'VARIANTS' && item.type === 'OFFER') {
          return !!innerIds.find((innerId) => item.variantsIds.includes(innerId))
        }

        return !!innerIds.find((innerId) => item.id === innerId)
      }

      return innerIds[0]?.toString()
    }

    const getDisabled = (item: Item) => {
      if (mode === 'INVENTORY_SHIPMENT' && item.type !== 'VARIANT') {
        return !item.hasHsCode
      }

      return productsStates[item.id]?.disabled.value
    }

    const getDisabledMessage = (item: Item) => {
      if (mode === 'INVENTORY_SHIPMENT') return

      return productsStates[item.id]?.disabled.message
    }

    return (
      <List
        data={items}
        bottomBorder={hasNextPage}
        renderItem={(item: Item) => (
          <MemoizedProductsListItem
            key={item.id}
            item={item}
            multiple={multiple}
            value={getValue(item)}
            mode={mode}
            selectMode={selectMode}
            disabled={getDisabled(item)}
            disabledMessage={getDisabledMessage(item)}
            onSelect={onSelect}
            onBulkSelect={onBulkSelect}
          />
        )}
      />
    )
  },
)
